import { deleteIssuesByIdVisibilitySlice } from './delete';
import { postIssuesByIdVisibilitySlice } from './post';

export const {
	requestDeleteIssuesByIdVisibility,
	resetDeleteIssuesByIdVisibility
} = deleteIssuesByIdVisibilitySlice.asyncActionCreators;

export const {
	requestPostIssuesByIdVisibility,
	resetPostIssuesByIdVisibility
} = postIssuesByIdVisibilitySlice.asyncActionCreators;
